import { useEffect, useState } from 'react';
import { BiChevronDown, BiChevronUp, BiDownArrow } from 'react-icons/bi';

import { DownwardArrowIcon } from '../../../../../assets/icons/DownwardArrowIcon';
import { ContentModalRedistribuicaoProps } from '../types/distribuicaoTypes';
import { getLeadsByUser } from '../utils/getLeadsByUser';
import { ButtonSubmit } from './ButtonSubimit';
import { TableModal } from './TableModal';

export const ContentModalRedistribuicao = ({
  objForContentModal
}: ContentModalRedistribuicaoProps) => {
  const [numberOfLeadsToTransfer, setNumberOfLeadsToTransfer] =
    useState<number>(0);

  const hasCondition =
    objForContentModal.originSeller &&
    objForContentModal.destinationSeller === 'Selecionar Vendedor'
      ? true
      : false;

  const handleNumberOfLeadsToCanTransfer = (value: number) => {
    const filteredUserLeads = objForContentModal.sellers.filter(
      (seller) => seller.id === objForContentModal?.originSellerId
    );

    const userLeads = filteredUserLeads[0].leads_disponiveis;

    const validNumberOfLeads = value <= userLeads;

    if (validNumberOfLeads) {
      setNumberOfLeadsToTransfer(value);
      objForContentModal.handleChangeLeadsToTransfer(value);
    } else {
      const errorMessage = 'Escolha uma quantidade de leads válida';
      objForContentModal.handleShowToast('open', errorMessage, 'warn');
    }
  };

  return (
    <div>
      <h2 className="tw-font-bold tw-pt-[10px]">
        RETIRAR os Leads do(a) vendedor(a):
      </h2>
      <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-gap-[20px] tw-mt-[10px]">
        <button
          className="tw-w-full md:tw-w-[70%] tw-h-[50px] tw-flex tw-items-center tw-justify-between tw-bg-[#FFFFFF] tw-p-[16px] tw-rounded-md tw-border-[1px] tw-border-[#D4D7DE] tw-focus:outline-none tw-focus:shadow-outline"
          onClick={() => objForContentModal.handleDropdownSelected('origin')}
        >
          <span className="tw-text-start tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis tw-max-w-[280px]">
            {objForContentModal.originSeller}
          </span>
          {objForContentModal.originDropdownSelected ? (
            <BiChevronUp className="tw-w-[24px] tw-h-[24px]" />
          ) : (
            <BiChevronDown className="tw-w-[24px] tw-h-[24px]" />
          )}
        </button>
        <input
          disabled={objForContentModal.originSeller === 'Selecionar Vendedor'}
          placeholder="Qtde. de Leads"
          type="number"
          value={numberOfLeadsToTransfer === 0 ? '' : numberOfLeadsToTransfer}
          className="tw-w-full md:tw-w-[180px] tw-h-[50px] tw-p-[16px] tw-rounded-md tw-border-[1px] tw-border-[#D4D7DE] tw-focus:outline-none tw-focus:shadow-outline"
          onChange={(e) => {
            const value = Number(e.target.value);

            handleNumberOfLeadsToCanTransfer(value);
          }}
        />
      </div>
      {!objForContentModal.originDropdownSelected && (
        <div className="">
          <div className="tw-flex tw-justify-center tw-py-[20px]">
            <DownwardArrowIcon />
          </div>
          <p className="tw-font-bold tw-pb-[4px] tw-text-[#FF5000]">
            ENVIAR os Leads para o(a) vendedor(a):
          </p>
          <button
            className="tw-mb-[20px] tw-flex tw-items-center tw-justify-between tw-bg-[#FFFFFF] tw-w-full tw-h-[50px] tw-p-[16px] tw-rounded-md tw-border-[1px] tw-border-[#D4D7DE] tw-focus:outline-none tw-focus:shadow-outline"
            onClick={() => {
              if (objForContentModal.originSeller !== 'Selecionar Vendedor') {
                objForContentModal.handleDropdownSelected('destination');
              } else {
                objForContentModal.handleShowToast(
                  'open',
                  'Selecione um vendedor para retirar os leads',
                  'warn'
                );
              }
            }}
          >
            <div className="">{objForContentModal.destinationSeller}</div>
            {objForContentModal.destinationDropdownSelected ? (
              <BiChevronUp className="tw-w-[24px] tw-h-[24px]" />
            ) : (
              <BiChevronDown className="tw-w-[24px] tw-h-[24px]" />
            )}
          </button>
          {objForContentModal.destinationDropdownSelected ? (
            <TableModal
              data={objForContentModal.sellers.filter(
                (vendedor: any) =>
                  vendedor.status === 'ativo' && vendedor.tipo !== 'gestor'
              )}
              identification={'redistribuicao'}
              handleChangeSeller={
                objForContentModal.handleChangeDestinationSeller
              }
            />
          ) : (
            <>
              <ButtonSubmit
                loading={false}
                condition={hasCondition}
                label=" Redistribuir"
                onSubmit={objForContentModal.handleRedistribuicao}
              />
              <button
                className="md:tw-hidden tw-mt-[20px] tw-bg-transparent tw-border-[#001E64] tw-border-[1px] tw-w-full tw-text-[#001E64] tw-py-[11px] tw-rounded-[134px]"
                onClick={objForContentModal.onClose}
              >
                Voltar
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};
